import React from 'react';
import resume, { Project } from '../../data/resume';
import styles from './Projects.module.css';

interface ProjectCardProps {
  project: Project;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project }) => (
  <div className={styles.card}>
    <h3 className={styles.title}>{project.title}</h3>
    <p className={styles.description}>{project.description}</p>
    <div className={styles.tags}>
      {project.tags.map((tag, i) => (
        <span key={i} className={styles.tag}>
          {tag}
        </span>
      ))}
    </div>
    {project.notebookUrl ? (
      <a
        href={`#notebook=${project.notebookUrl.split('/').pop()}`}
        className={styles.viewBtn}
      >
        View Notebook
      </a>
    ) : project.link ? (
      <a href={project.link.url} className={styles.viewBtn}>
        {project.link.label}
      </a>
    ) : null}
  </div>
);

const GROUPS: { key: Project['group']; label: string; subheading: string }[] = [
  {
    key: 'no_libraries',
    label: 'From Scratch',
    subheading: 'Core ML algorithms built from first principles using only NumPy and Pandas.',
  },
  {
    key: 'with_libraries',
    label: 'Applied ML',
    subheading: 'End-to-end ML projects using standard libraries on real-world datasets.',
  },
  {
    key: 'misc',
    label: 'Miscellaneous',
    subheading: 'Other projects outside of machine learning.',
  },
];

const Projects: React.FC = () => (
  <section id="projects" className={styles.section}>
    <div className={styles.inner}>
      <h2 className={styles.sectionTitle}>ML Projects</h2>
      {GROUPS.map(({ key, label, subheading }) => {
        const group = resume.projects.filter((p) => p.group === key);
        if (group.length === 0) return null;
        return (
          <div key={key} className={styles.group}>
            <h3 className={styles.groupLabel}>{label}</h3>
            <p className={styles.groupSubheading}>{subheading}</p>
            <div className={styles.grid}>
              {group.map((project, i) => (
                <ProjectCard key={i} project={project} />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  </section>
);

export default Projects;
